// @ts-nocheck
// @ts-nocheck
import LoginPageStyles from "./LoginPage.module.scss";
import { useGoogleLogin } from "@react-oauth/google";
import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Auth } from "../../auth/auth";
import { ROUTES } from "../../common/constants";
import { getTokensFromGAuthCode } from "../../services/auth.service";
import MayoIrisSvg from "../../assets/images/mayo_iris_logo.svg";
import LumaSvg from "../../assets/images/luma_login_logo.svg";
import { getProjectMappings } from "../../services/auth.service";
const LoginPage = () => {
  const [projectName, setProjectName] = useState("");
  const navigate = useNavigate();
  const auth = Auth.getInstance();

  useEffect(() => {
    const fetchProjectName = async () => {
      try {
        const response = await getProjectMappings();
        if (
          response &&
          response.project_names &&
          response.project_names.length > 0
        ) {
          const projectName = response.project_names[0];
          localStorage.setItem("projectName", projectName);
          setProjectName(projectName);
          document.title = projectName.toUpperCase();
          const link = document.querySelector(
            "link[rel*='icon']"
          ) as HTMLLinkElement | null;
          if (link) {
            link.href = `${
              process.env.PUBLIC_URL
            }/${projectName.toLowerCase()}_logo.svg`;
          } else {
            const newLink = document.createElement("link");
            newLink.type = "image/x-icon";
            newLink.rel = "shortcut icon";
            newLink.href = `${
              process.env.PUBLIC_URL
            }/${projectName.toLowerCase()}_logo.svg`;
            document.getElementsByTagName("head")[0].appendChild(newLink);
          }
        }
      } catch (error) {
        console.error("Error fetching project name:", error);
      }
    };

    fetchProjectName();
  }, []);

  const handleClick = useGoogleLogin({
    scope: `https://www.googleapis.com/auth/drive.readonly https://www.googleapis.com/auth/documents`,
    flow: "auth-code",
    onSuccess: async (tokenResponse) => {
      const res = await getTokensFromGAuthCode({
        code: tokenResponse?.code,
        redirect_uri: process.env.REACT_APP_GOOGLE_AUTH_REDIRECT_URI_MAYO_DEV,
      });
      auth.saveGoogleCodes({
        access_token: res?.access_token,
        refresh_token: res?.refresh_token,
        code: tokenResponse?.code,
      });

      const loginResponse = await auth.login({
        access_token: res?.access_token,
      });

      if (loginResponse.isAuthenticated) {
        navigate(ROUTES.dashboard);
      }
    },
    onError: (error) => {},
  });
  useEffect(() => {
    if (auth.getAccessToken() !== null) {
      navigate(ROUTES.dashboard);
    }
  }, [auth, navigate]);

  return (
    <div className={LoginPageStyles.loginWrapper}>
      <div className={LoginPageStyles.loginbox}>
        <div className={LoginPageStyles.content}>
          <div className={LoginPageStyles.logo}>
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "flex-start",
              }}
            >
              {projectName === "Luma" ? (
                <img src={LumaSvg} alt="Luma Logo" />
              ) : (
                <img src={MayoIrisSvg} alt="Mayo Logo" />
              )}
            </div>
          </div>

          <div className={LoginPageStyles.tagline}>
            {projectName === "Mayo" ? (
              <h2>Transform the Way You Create Health Content</h2>
            ) : (
              <h2>Transform the Way You Create Content</h2>
            )}
            <p>Smarter, Faster, Together</p>
          </div>

          <div onClick={handleClick} className={`${LoginPageStyles.loginBtn} `}>
            <span>Sign in with SSO</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LoginPage;
